export class HarperBlockPortal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.fetchHTML()
  }

  fetchHTML () {
    return window.BAO.sectionRenderer
      .fetchSingle('harper-block')
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const block = newDOM.querySelector('[data-harper-block-el="block"]')
        this.appendChild(block)
      })
      .catch(() => {
        console.error('Failed to fetch harper block HTML')
      })
  }
}

if (!customElements.get('harper-block')) {
  customElements.define('harper-block', HarperBlockPortal)
}
